import comp from "./StudentsList";
export default comp;
